import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskRcaInvestigationRoute: InvariantJiraRoute = {
	name: 'servicedesk-rca-investigation',
	path: '/jira/servicedesk/projects/:projectKey/investigation/:id',
	exact: true,
};
